var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgGridFilled = function SvgGridFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111",
    d: "M4.5 0a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM15.5 0a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM4.5 11a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9ZM15.5 11a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGridFilled);
export default ForwardRef;